import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import TableContainer from "src/components/Common/TableContainer";
import { useNavigate } from "react-router";
import ModalValidation from "../../Forms/FormValidation/financing/ModalValidation";
import { useSelector } from "react-redux";
import useToast from "src/components/Common/toast";

const ProjectFinancing = () => {
  document.title = "Financiadores - Khozi";
  const navigate = useNavigate();
  const [modal, setModal] = useState<boolean>(false);
  const [financingList, setFinancingList] = useState<any>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const { show, ToastComponent } = useToast();
  const [successDelete, setSuccessDelete] = useState(false);
  const [errorDelete, setErrorDelete] = useState(false);
  const [successUpdate, setSuccessUpdate] = useState(false);
  const [errorUpdate, setErrorUpdate] = useState(false);

  useEffect(() => {
    if (errorDelete) {
      show("Erro", "Erro ao apagar o financiador.");
      setErrorDelete(false);
    } else if (successDelete) {
      show("Sucesso", "Financiador apagado com sucesso.");
      setSuccessDelete(false);
    } else if (errorUpdate) {
      show("Erro", "Erro ao actualizar o financiador.");
      setErrorUpdate(false);
    } else if (successUpdate) {
      show("Sucesso", "Financiador actualizado com sucesso.");
      setSuccessUpdate(false);
    }
  }, [successDelete, errorDelete, successUpdate, errorUpdate]);

  const financing = useSelector((state: any) => state.financing.financing);

  const toggle = () => {
    setModal(!modal);
  };

  const handleRowClick = (arg: any) => {
    const financing = arg;
    setFinancingList({
      id: financing.id,
      name: financing.nome,
      valor_previsto: financing.valor_previsto,
      descricao: financing.descricao,
    });
    setIsEdit(true);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "Nome",
        accessor: "nome",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Descrição",
        accessor: "descricao",
        disableFilters: true,
        filterable: true,
      },
      // {
      //   Header: "Valor Previsto (MZN)",
      //   accessor: "valor_previsto",
      //   disableFilters: true,
      //   filterable: true,
      //   Cell: ({ value }: { value: number }) => {
      //     const formattedValue = new Intl.NumberFormat("pt-MZ", {
      //       minimumFractionDigits: 2,
      //       maximumFractionDigits: 2,
      //     }).format(value);
      //     return `${formattedValue}`;
      //   },
      // },
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {ToastComponent}
          <Breadcrumbs title="Projetos" breadcrumbItem="Financiadores" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <TableContainer
                    addButtonLabel="Novo Financiador"
                    columns={columns}
                    data={financing}
                    isGlobalFilter={true}
                    isAddUserList={true}
                    isOptionalAdd={true}
                    customPageSize={10}
                    className="custom-header-css"
                    handleUserClick={() => {
                      navigate("/projects/financing/create");
                    }}
                    handleRowClick={handleRowClick}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle} centered={true}>
            <ModalHeader toggle={toggle} tag="h4">
              Editar {financingList.name}
            </ModalHeader>
            <ModalBody>
              <ModalValidation
                selectedFinancing={financingList}
                setModal={setModal}
                setSuccessDelete={setSuccessDelete}
                setErrorDelete={setErrorDelete}
                setSuccessUpdate={setSuccessUpdate}
                setErrorUpdate={setErrorUpdate}
              />
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProjectFinancing;
